/* Luxe Supply: carry ad and campaign tags to the portal (2026-10-23, Dan / Claude). */
/* Reads gclid/gbraid/wbraid/msclkid/oppref, utm_* and ref from the URL, keeps */
/* them 30 days in a first-party cookie (no personal data), and appends them to */
/* every portal.luxesupply.co link so the portal's attribution sees them. */
/* v2 (10/23): also remembers the site that sent the visitor here (lsc_ref, a */
/* host name only, e.g. google.com) and marks portal links entry=luxesupply.co, */
/* so organic search that came through this site is credited to our SEO. */
/* To undo: remove its script_tag line from layout/theme.liquid. */
(function () {
var KEYS = ['gclid','gbraid','wbraid','msclkid','oppref','utm_source','utm_medium','utm_campaign','utm_term','utm_content','ref'];
var PAID = ['gclid','gbraid','wbraid','msclkid','oppref'];
var NAME = 'lsc_mkt';
var MAX_AGE = 30 * 24 * 3600;
var ENTRY = 'luxesupply.co';
function clean(v) { return String(v).replace(/[^\w.\-~:+]/g, '').slice(0, 200); }
function readStored() {
try {
var m = document.cookie.match(/(?:^|; )lsc_mkt=([^;]*)/);
return m ? JSON.parse(decodeURIComponent(m[1])) : {};
} catch (e) { return {}; }
}
function writeStored(obj) {
try {
var v = encodeURIComponent(JSON.stringify(obj));
document.cookie = NAME + '=' + v + '; Max-Age=' + MAX_AGE + '; Path=/; Domain=.luxesupply.co; SameSite=Lax; Secure';
} catch (e) {}
}
function fromUrl() {
var out = {};
try {
var q = new URLSearchParams(location.search);
for (var i = 0; i < KEYS.length; i++) {
var v = q.get(KEYS[i]);
if (v) out[KEYS[i]] = clean(v);
}
} catch (e) {}
return out;
}
function externalReferrer() {
try {
if (!document.referrer) return '';
var h = new URL(document.referrer).hostname.toLowerCase().replace(/^www\./, '');
if (!h || h === 'luxesupply.co' || /\.luxesupply\.co$/.test(h)) return '';
return /^[a-z0-9.-]{1,100}$/.test(h) ? h : '';
} catch (e) { return ''; }
}
var stored = readStored();
var incoming = fromUrl();
var changedStore = false;
if (Object.keys(incoming).length) {
var next = {};
if (stored.ref && !incoming.ref) next.ref = stored.ref;
if (stored.lsc_ref) next.lsc_ref = stored.lsc_ref;
for (var k in incoming) next[k] = incoming[k];
var hasPaid = false;
for (var j = 0; j < PAID.length; j++) if (incoming[PAID[j]]) hasPaid = true;
if (!hasPaid) {
for (var p = 0; p < PAID.length; p++) if (stored[PAID[p]] && !next[PAID[p]] && !incoming.utm_source) next[PAID[p]] = stored[PAID[p]];
}
stored = next;
changedStore = true;
}
var landingRef = externalReferrer();
if (landingRef && stored.lsc_ref !== landingRef) {
stored.lsc_ref = landingRef;
changedStore = true;
}
if (changedStore) writeStored(stored);
function decorate(url) {
try {
var u = new URL(url, location.href);
if (u.hostname !== 'portal.luxesupply.co') return null;
var changed = false;
for (var key in stored) {
if (stored[key] && !u.searchParams.has(key)) { u.searchParams.set(key, stored[key]); changed = true; }
}
if (!u.searchParams.has('entry')) { u.searchParams.set('entry', ENTRY); changed = true; }
return changed ? u.toString() : null;
} catch (e) { return null; }
}
function decorateLink(a) {
if (!a || !a.getAttribute) return;
var href = a.getAttribute('href');
if (!href || href.indexOf('portal.luxesupply.co') === -1) return;
var n = decorate(href);
if (n) a.setAttribute('href', n);
}
function decorateForm(f) {
var act = f.getAttribute && f.getAttribute('action');
if (!act || act.indexOf('portal.luxesupply.co') === -1) return;
var n = decorate(act);
if (n) f.setAttribute('action', n);
}
function sweep(root) {
var links = (root || document).querySelectorAll('a[href*="portal.luxesupply.co"]');
for (var i = 0; i < links.length; i++) decorateLink(links[i]);
var forms = (root || document).querySelectorAll('form[action*="portal.luxesupply.co"]');
for (var f = 0; f < forms.length; f++) decorateForm(forms[f]);
}
function onPointer(e) {
var el = e.target && e.target.closest ? e.target.closest('a[href]') : null;
if (el) decorateLink(el);
}
document.addEventListener('mousedown', onPointer, true);
document.addEventListener('touchstart', onPointer, { capture: true, passive: true });
document.addEventListener('click', onPointer, true);
document.addEventListener('keydown', function (e) { if (e.key === 'Enter') onPointer(e); }, true);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { sweep(); });
else sweep();
try {
new MutationObserver(function () { sweep(); }).observe(document.documentElement, { childList: true, subtree: true });
} catch (e) {}
})();
